const timePickerLocalization = {
  chooseTime: 'Choose time',
}

export default timePickerLocalization
